// Circular `!` badge used to flag planning problems. `warning` = yellow, `error` = red.
import ExclamationIcon from '../../assets/icons/exclamation.svg?react';
import styles from './WarningSign.module.css';

interface WarningSignProps {
  variant: 'warning' | 'error';
  className?: string;
}

export const WarningSign = ({ variant, className }: WarningSignProps) => {
  const variantClass = variant === 'error' ? styles.error : styles.warning;
  return (
    <span className={`${styles.root} ${variantClass} ${className ?? ''}`}>
      <ExclamationIcon className={styles.icon} aria-hidden="true" />
    </span>
  );
};
